var _excluded = ["children", "light"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import PropTypes from 'prop-types';
import { StyledSkeleton } from './Styles';
function Skeleton(_ref) {
  var children = _ref.children,
    light = _ref.light,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/React.createElement(StyledSkeleton, _extends({}, rest, {
    light: +light
  }), children);
}
Skeleton.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * The animation. If `false` the animation effect is disabled.
   */
  animation: PropTypes.oneOf(['pulse', 'wave']),
  /**
   * React component, HTML node, string etc..
   */
  children: PropTypes.node,
  /**
   * Height of the skeleton. Useful when you don't want to adapt
   * the skeleton to a text element but for instance a card.
   */
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * If `true`, renders light version. Typically used when parent
   * component have dark background
   */
  light: PropTypes.bool,
  /**
   * The type of content that will be rendered.
   */
  variant: PropTypes.oneOf(['circular', 'rectangular', 'text']),
  /**
   * Width of the skeleton. Useful when the skeleton is inside
   * an inline element with no width of its own.
   */
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
} : {};
Skeleton.defaultProps = {
  animation: 'pulse',
  children: '',
  height: '',
  light: false,
  variant: 'text',
  width: ''
};
export default Skeleton;